import React from 'react';
import { Link } from 'react-router-dom';

export default function NavBar() {
  return (
    <header className="bg-white shadow-sm border-b">
      <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          <div className="flex items-center space-x-4">
            <Link to="/" className="flex items-center gap-3">
              <img src="/logo-sedim.jpg" alt="logo" className="h-10 w-10 rounded-md object-cover" />
              <div className="leading-tight">
                <div className="text-sm font-semibold text-gray-800">School Management System</div>
                <div className="text-xs text-gray-500"></div>
              </div>
            </Link>
          </div>
          <div className="flex-1 flex justify-center">
            <div className="text-xl font-bold text-indigo-600">School MIS</div>
          </div>
          <div className="flex items-center space-x-4">
            <Link to="/students" className="px-4 py-2 text-sm font-medium text-gray-700 hover:text-indigo-600 hover:bg-gray-50 rounded-lg transition-colors">
              Home
            </Link>
            <div className="flex items-center gap-3">
              <img src="/user.png" alt="avatar" className="h-10 w-10 rounded-full object-cover border" />
              <div className="text-sm text-left">
                <div className="font-medium text-gray-800">Sameer Hapani</div>
                <div className="text-xs text-gray-500">Teacher</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
